import { PipeModule } from 'src/app/core/pipes/pipe.module';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { NgModule } from "@angular/core";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { AuthGuard } from "./guards/auth.guard";
import { AppService } from "./services/app.service";
import { ModuleWithProviders } from "@angular/core";
import { DirectivesModule } from "./directives/directives.module";
import { MatExpansionModule } from '@angular/material/expansion';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { EmojiModule } from '@ctrl/ngx-emoji-mart/ngx-emoji';

import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatSliderModule } from '@angular/material/slider';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CanDeactivateGuard } from './guards/can-deactivate-guard';
import { TopHeaderComponent } from '../pages/layout/top-header/top-header/top-header.component';
import { RouterModule } from '@angular/router';
import { UserInfoGuard } from './guards/user-info.guard';
import { StreamMetricsDialogComponent } from '../pages/components/user/stream-metrics-dialog/stream-metrics-dialog.component';
// import { LiveEventsComponent } from '../pages/layout/live-events/live-events.component';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { SocialShareLinkComponent } from '../pages/layout/social-share-link/social-share-link.component';
import { ShareService } from 'ngx-sharebuttons';
// import { QAndAComponent } from '../pages/layout/q-and-a/q-and-a.component';
import { HeaderComponent } from '../pages/components/website/layout/header/header.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MobileDeviceFooterComponent } from '../pages/components/website/pages/mobile-device-footer/mobile-device-footer.component';
// import { PollComponent } from '../pages/layout/poll/poll.component';
import { EventTermsConditionsComponent } from '../pages/components/event-navigation/pages/event-terms-conditions/event-terms-conditions.component';

import { UserDashboardHeaderComponent } from '../pages/components/user-dashboard/user-dashboard-header.component';
import { EventMenuComponent } from '../pages/components/event-navigation/layout/event-menu/event-menu.component';
import { GoogleTranslateComponent } from '../pages/components/general/google-translate/google-translate.component';
import { NgxIntlTelInputModule } from "ngx-intl-tel-input-gg";
import { VideoJSComponent } from '../pages/components/user/vod/video.component';
import { UpcomingEventsComponent } from '../pages/components/website/pages/upcoming-events/upcoming-events.component';
import { HomeUpdatesComponent } from '../pages/components/website/pages/home-updates/home-updates.component';
import { ChannelWebpageGuard } from './guards/channel-webpage.guard';
import { SubscriptionListComponent } from '../pages/components/user/subscription-list/subscription-list.component';
import { ConsumerSignupComponent } from '../pages/components/landing-pages/consumer/consumer-signup/consumer-signup.component';
import { ConsumerSignupV2Component } from '../pages/components/landing-pages/consumer/consumer-signup-v2/consumer-signup-v2.component';
import { MobileAppDownloadComponent } from "../pages/components/landing-pages/consumer/mobile-app/mobile-app-download.component";

import { PrivacyPolicyComponent } from '../pages/components/landing-pages/privacy-policy/privacy-policy.component';
import { CookiePloicyComponent } from '../pages/components/landing-pages/cookie-ploicy/cookie-ploicy.component';
import { TermsAndConditionsComponent } from '../pages/components/landing-pages/terms-and-conditions/terms-and-conditions.component';
import { ContactUsComponent } from '../pages/components/landing-pages/contact-us/contact-us.component';
import { PaymentComponent } from '../pages/components/general/payment/payment.component';
import { MerchandiseComponent } from '../pages/layout/merchandise/merchandise.component';
import { SavedCardsComponent } from '../pages/components/general/saved-cards/saved-cards.component';
import { DefaultAddressComponent } from '../pages/components/general/default-address/default-address.component';
import { UserAccountDialog } from '../pages/components/event-navigation/pages/event-tickets/event-tickets.component';
import { HomeV4Component } from '../pages/components/website/static-website-v4/home-v4/home-v4.component';
import { SubscribePaymentComponent } from '../pages/components/general/subscribe-payment/subscribe-payment.component';
import { PaymentTransactionsComponent } from '../pages/components/general/payment-transactions/payment-transactions.component';
import { TipsFeedbackPopupComponent } from '../pages/components/user/tips-feedback-popup/tips-feedback-popup.component';
import { SvgComponent } from '../svg/svg.component';
import { WebsiteFooterComponent } from '../pages/components/website/layout/website-footer/website-footer.component';
import { FooterComponent } from '../pages/layout/footer/footer.component';
import { CryptoInstructionsComponent } from '../pages/components/user-dashboard/crypto-instructions/crypto-instructions.component';
import { NgxGpAutocompleteModule } from '@angular-magic/ngx-gp-autocomplete';
import { Loader } from "@googlemaps/js-api-loader";
import { environment } from "src/environments/environment";

export const CORE_PROVIDERS = [AuthGuard, UserInfoGuard, AppService, CanDeactivateGuard,ChannelWebpageGuard];

const maskOptions: Partial<any> = {

};

@NgModule({
  declarations: [
    PaymentTransactionsComponent,
    SubscribePaymentComponent,
    PaymentComponent,
    UpcomingEventsComponent,
    HomeUpdatesComponent,
    HomeV4Component,
    GoogleTranslateComponent,
    TopHeaderComponent,
    StreamMetricsDialogComponent,
    // LiveEventsComponent,
    SocialShareLinkComponent,
    // QAndAComponent,
    // PollComponent,
    HeaderComponent,
    MobileDeviceFooterComponent,
    EventTermsConditionsComponent,
    UserDashboardHeaderComponent,
    EventMenuComponent,
    VideoJSComponent,
    SubscriptionListComponent,
    PrivacyPolicyComponent,
    CookiePloicyComponent,
    TermsAndConditionsComponent,
    ContactUsComponent,
    ConsumerSignupComponent,
    MobileAppDownloadComponent,
    MerchandiseComponent,
    SavedCardsComponent,
    DefaultAddressComponent,
    UserAccountDialog,
    TipsFeedbackPopupComponent,
    SvgComponent,
    WebsiteFooterComponent,
    SubscribePaymentComponent,
    FooterComponent,
    CryptoInstructionsComponent
  ],
  imports: [
    MatSlideToggleModule,
    CommonModule,
    DirectivesModule,
    ConsumerSignupV2Component,
    FlexLayoutModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTableModule,
    MatRadioModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSelectModule,
    MatDividerModule,
    MatChipsModule,
    MatExpansionModule,
    RouterModule,
    MatSidenavModule,
    MatProgressBarModule,
    PipeModule,
    MatTooltipModule,
    CarouselModule.forRoot(),
    MatTabsModule,
    // GooglePlaceModule,
    PickerModule,
    EmojiModule,
    MatSliderModule,
    ShareButtonsModule.withConfig({
      debug: true
    }),
    ShareIconsModule,
    NgxIntlTelInputModule,
    NgxGpAutocompleteModule
  ],
  exports: [
    PaymentTransactionsComponent,
    SubscribePaymentComponent,
    PaymentComponent,
    GoogleTranslateComponent,
    MatSlideToggleModule,
    DirectivesModule,
    FlexLayoutModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTableModule,
    MatMenuModule,
    MatRadioModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatSelectModule,
    MatDividerModule,
    MatChipsModule,
    MatExpansionModule,
    TopHeaderComponent,
    RouterModule,
    MatSidenavModule,
    PipeModule,
    MatTooltipModule,
    MatTabsModule,
    MatProgressBarModule,
    // GooglePlaceModule,
    PickerModule,
    EmojiModule,
    MatSliderModule,
    SocialShareLinkComponent,
    // LiveEventsComponent,
    // QAndAComponent,
    // PollComponent,
    HeaderComponent,
    MobileDeviceFooterComponent,
    EventTermsConditionsComponent,
    UserDashboardHeaderComponent,
    EventMenuComponent,
    NgxIntlTelInputModule,
    VideoJSComponent,
    UpcomingEventsComponent,
    SubscriptionListComponent,
    PrivacyPolicyComponent,
    CookiePloicyComponent,
    ContactUsComponent,
    TermsAndConditionsComponent,
    ConsumerSignupComponent,
    MobileAppDownloadComponent,
    HomeUpdatesComponent,
    MerchandiseComponent,
    SavedCardsComponent,
    DefaultAddressComponent,
    UserAccountDialog,
    HomeV4Component,
    MerchandiseComponent,
    TipsFeedbackPopupComponent,
    SvgComponent,
    WebsiteFooterComponent,
    SubscribePaymentComponent,
    FooterComponent,
    CryptoInstructionsComponent,
    NgxGpAutocompleteModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [
    ShareService,
    {
      provide: Loader,
      useValue: new Loader({
        apiKey: environment.mapKey,
        libraries: ['places'],
      }),
    },
  ]

})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return{
      ngModule: CoreModule,
      providers: [...CORE_PROVIDERS,CurrencyPipe],
    };
  }
}
